export default __webpack_public_path__ + "static/media/music.c8f5d615.svg";